import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Ventures from "@/pages/Ventures";
import Films from "@/pages/Films";
import Press from "@/pages/Press";
import Journal from "@/pages/Journal";
import JournalPost from "@/pages/JournalPost";
import Contact from "@/pages/Contact";
import { Toaster } from "@/components/ui/sonner";

// Preserve indexed /news/* URLs — redirect to the merged /journal namespace.
const NewsSlugRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={`/journal/${slug}`} replace />;
};

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/ventures" element={<Ventures />} />
            <Route path="/films" element={<Films />} />
            <Route path="/press" element={<Press />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/journal/:slug" element={<JournalPost />} />
            <Route path="/news" element={<Navigate to="/journal" replace />} />
            <Route path="/news/:slug" element={<NewsSlugRedirect />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </>
  );
}

export default App;
